import styled from 'styled-components';

export const AddReviewModalTitle = styled.div`
  font-size: 18px;
  font-family: 'Poppins';
  font-weight: 700;
  text-align: center;
`;

export const RateInputsWrapper = styled.div`
  margin-bottom: 3rem;
`;

export default { RateInputsWrapper, AddReviewModalTitle };
